import api from "../_helpers/mainapi";
import { setLoading } from "./common.actions";
//import _ from "lodash";

export const getLanguagesTable = () => async (dispatch, getState) => {
  dispatch(setLoading(true));
  let response = await api.get(`/pagelanguage/getall`);
  dispatch(setLoading(false));
  return response.data;
};

export const getBySymbol = (langSymbol) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  const response = await api.get(`/pagelanguage/getbysymbol`, { params: { langSymbol } });
  dispatch(setLoading(false));
  return response.data;
};

export const saveLang = (lang) => async (dispatch, getState) => {
  const response = await api.post(`/pagelanguage/savelang`, lang);
  return response.data;
};

export const removeLang = (lang) => async (dispatch, getState) => {
  const response = await api.post(`/pagelanguage/deletelang`, lang);
  return response.data;
}
export const getAllPageTranslationsForLanguage = (langId) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  let response = await api.get(`/pagelanguage/getallpagetranslationsforlanguage`, { params: { langId } });
  dispatch(setLoading(false));
  return response.data;
};

export const savePageTranslations = (pageLanguageId, pageLanguageTranslations) => async (dispatch, getState) => {
  const formData = new FormData();
  if (pageLanguageId) formData.append("pageLanguageId", pageLanguageId);
  formData.append("pageLanguageTranslationsListAsJson", JSON.stringify(pageLanguageTranslations));
  const response = await api.post(`/pagelanguage/savepagetranslations`, formData);
  return response.data;
};

